import { Box, HStack, Input, VStack} from '@chakra-ui/react';
import React, { forwardRef, useRef, useState, useEffect, useCallback } from 'react'
import * as getSearchResultData from "../services/Search";
import SmallBold from '../Theme/Typography/SmallBold';
import Small from '../Theme/Typography/Small';
import { RiArrowRightFill } from "react-icons/ri";
import { common } from '../constants/constants';
import { useNavigate } from 'react-router-dom';
import { cleanText, HtmlRenderer } from '../util/helper';
import { useDebounce } from '../hooks/useDebounce';

export const SearchTags = forwardRef(({ handleSearch, naviagateSearch, showSuggestion, setShowSuggestion,inputValue, setInputValue, onSearchClose}, ref) => {
  const [tags, setTags] = useState([]);
    const [suggestions, setSuggestions] = useState([]);
    const [keywordPresent,setKeywordPresent]=useState(false)
    const inputRef = useRef(null);
    const navigate=useNavigate();
    
    // Debounce the input value with 300ms delay
    const debouncedInputValue = useDebounce(inputValue, 300);
    
    const fetchSuggestions = useCallback(async (query) => {
      try {
        const result = await getSearchResultData.getSuggestionData(query);
        if (result && result?.data) {
          // For future use
          // const cleanedData = result.data.map((item) =>
          //   item.replace(/<\/?em>/g, "")
          // );
          setSuggestions(result?.data);
          setShowSuggestion(true);
          const hasExactSearchFalse = result?.data.some(item => item.exactSearch === false);    
          if (hasExactSearchFalse) {
              setKeywordPresent(true);
          }else{
            setKeywordPresent(false)
          }
        }
      } catch (error) {
        console.error("Error fetching suggestions:", error);
      }
    }, [setShowSuggestion]);
    
    // Effect to handle debounced search
    useEffect(() => {
      if (debouncedInputValue && debouncedInputValue.trim() !== "") {
        fetchSuggestions(debouncedInputValue);
      }
    }, [debouncedInputValue, fetchSuggestions]);
    
    const handleInputChange = (event) => {
      const value = event.target.value;
      setInputValue(value);
      handleSearch(value);
      
      // Clear suggestions immediately if input is empty
      if (value.trim() === "") {
        setSuggestions([]);
        setShowSuggestion(false);
      }
    };
  const handleKeyDown = (event) => {
    if (event.key === "Enter" && inputValue.trim() !== '') {
      setTags([...tags, inputValue.trim()]);
      naviagateSearch(inputValue)
      setShowSuggestion(false)
      setSuggestions([]);
    }
  };
  const handleAutosuggest = (suggestion) => {
    setInputValue(suggestion);
    handleSearch(suggestion);
    setSuggestions([]);
    setShowSuggestion(false);
    naviagateSearch(suggestion);
  };
  // const handleClick = () => {
  //   if (inputRef.current) {
  //     inputRef.current.select();
  //   }
  // };
  const handleNavigation = (suggestion) => {
    setShowSuggestion(false); // Close the suggestion box
    onSearchClose(); // Close the search modal
    if (!suggestion?.route) {
      handleAutosuggest(suggestion?.alias);
      return;
    }
  
    // const path = suggestion.route.includes('generic')
    //   ? `${suggestion.route}/research-centre/all`
    //   : suggestion.route;
    const { route, alias } = suggestion || {};
    const path = route?.includes('search/') || route?.includes('generic/')
      ? `search/research-centre/all?query=${alias}`
      : `${route}/agraphy`;

    setInputValue(cleanText(suggestion?.title));
    navigate(path);
  };
  
  return (
    <Box>
      <Input
        width={{ base: "350px", md: "535px" }} 
        outline="none"
        border="none"
        height={{base:"44px",md:"44px"}}
        pr={{ base: "3rem", md: "3rem" }}
        pl={4}
        color="color.primary"
        bg="transparent"
        placeholder="Search..."
        _placeholder={{ 
          color: "color.lightgray2", 
          fontSize:"15px", 
          lineHeight:"20px",
          fontWeight: "400"
        }} 
        _focus={{
          outline: "none",
          boxShadow: "none",
          border: "none"
        }}
        _hover={{
          outline: "none",
          border: "none"
        }}
        fontSize="15px"
        fontWeight="400"
        value={inputValue}
        ref={inputRef}
        onChange={handleInputChange}
        onKeyDown={handleKeyDown}
      />
       {showSuggestion && suggestions.length > 0 && (
        <VStack
          width={{base:"100%",md:"535px"}}
          ref={ref}
          pos={"absolute"}
          top={{base:"35px",md:"47px"}}
          border={"1px"}
          borderColor={"color.lightgray4"}
          borderRadius={"5px"}
          right={0}
          className="searchscrollbar"
          height={"320px"}
              overflowY={"scroll"}
              overflowX={"hidden"}
          bg="white"
          align="stretch"
          spacing={1}
        >
          <Box>
          {suggestions?.map((suggestion, index) => (
            <>
            {suggestion?.exactSearch &&<HStack
              pl={{base:"4",md:"2"}}
              pr={"2"}
              py={1}
              key={index}
              spacing={2}
              justifyContent={"space-between"}
              _hover={{ bg: "gray.100" }}
              cursor="pointer"
              onClick={()=>handleNavigation(suggestion)}
            >
              <Small fontSize="12px!important" lineHeight="20px" width={{base:"100%",md:"485px"}} color="#000000">
                <HtmlRenderer htmlString={cleanText(suggestion?.displayTitle)} />
                </Small>
              <RiArrowRightFill fontSize={"20px"} color="#035DA1" />
            </HStack>}
            </>
          ))}
          </Box>
         <Box>
            <>
            {keywordPresent  &&
              <Box bg="white" borderBottom={{base:"0px",md:"1px"}} borderColor={{base:'#efefef',md:"#efefef"}} width={{base:"100%",md:"390px"}}>
                <SmallBold px={{base:"4",md:"2"}} py="2" color="#000000">{common.DID_YOU_MEAN}</SmallBold>
                </Box>
            }
            </>
          {suggestions?.map((suggestion, index) => (
            <>
            {!suggestion?.exactSearch &&
            <>
            <HStack
              pl={{base:"4",md:"2"}}
              pr={"2"}
              py={1}
              key={index}
              spacing={2}
              justifyContent={"space-between"}
              _hover={{ bg: "gray.100" }}
              cursor="pointer"
              onClick={()=>handleNavigation(suggestion)}
            >
              <Small fontSize="14px!important" lineHeight="20px" width={{base:"100%",md:"255px"}} color="#000000">
                <HtmlRenderer htmlString={ suggestion?.displayTitle } />
                </Small>
              <RiArrowRightFill fontSize={"20px"} color="#035DA1" />
            </HStack>
            </>
            }
            </>
          ))}
          </Box>
        </VStack>
      )}
      {/* <Wrap top="10px" left={"12px"} pos={"absolute"}>
        {tags.map((tag, index) => (
          <WrapItem key={index}>
            <Tag borderRadius="full" variant="solid" colorScheme="blue">
              <TagLabel>{tag}</TagLabel>
              <TagCloseButton onClick={() => handleTagClose(tag)} />
            </Tag>
          </WrapItem>
        ))}
      </Wrap> */}
    </Box>
  );
})

